

import * as csstips from 'csstips'
import * as ReactDOM from 'react-dom'
import * as ReactiveLens from 'reactive-lens'

import * as App from './Editor'

declare const module: {hot: {accept: Function}}

const global = (window as any) as {reattach: Function}

if (global.reattach === undefined) {
  csstips.normalize()
  csstips.setupPage('body')
  const root = document.body.appendChild(document.createElement('div'))
  global.reattach = ReactiveLens.attach(vn => ReactDOM.render(vn, root), App.init, App.App)
}

if (module.hot) {
  module.hot.accept(() => {
    global.reattach(App.App)
  })
}
